import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const AuthCallback: React.FC = () => {
  const { session, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (session) {
      const dest = localStorage.getItem('postLoginRedirect') || '/';
      localStorage.removeItem('postLoginRedirect');
      navigate(dest, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [session, loading, navigate]);

  return (
    <Container className="p-5 my-5 text-center">
      <Spinner animation="border" className="mb-3" />
      <p>Signing you in...</p>
    </Container>
  );
};

export default AuthCallback;
